// extracted by mini-css-extract-plugin
export default {"coordinate-tabs":"coordinate-tabs_coordinate-tabs__P-4OJ"};